interface FormHeaderProps {
  title: string;
  subtitle?: string;
}

export const FormHeader = ({ title, subtitle }: FormHeaderProps) => {
  return (
    <div className="space-y-3 text-center">
      {/* h2: the page h1 is the screen's title in AuthLayout. Midnight Indigo, as skillpanel.com's
      headlines: FormHeader only appears on the front door */}
      <h2 className="text-3xl font-semibold tracking-tight text-brand">{title}</h2>
      {!!subtitle && <p className="text-base text-muted-foreground leading-relaxed">{subtitle}</p>}
    </div>
  );
};
